import { render, staticRenderFns } from "./section-hero.vue?vue&type=template&id=3ec3de89&scoped=true"
import script from "./section-hero.vue?vue&type=script&lang=js"
export * from "./section-hero.vue?vue&type=script&lang=js"
import style0 from "./section-hero.vue?vue&type=style&index=0&id=3ec3de89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3de89",
  null
  
)

export default component.exports